export const site = {
  whatsappNumber: '5545998218775',
  phoneDisplay: '(45) 99821-8775',
  email: 'atendimento@rmssofthouse.com',
  loginUrl: 'https://crm.contdesk.app/',
  rmsUrl: 'https://rmssofthouse.com',
  privacyUrl: '/privacidade',
  termsUrl: '/termos',
  cookiesUrl: '/cookies',
  // Cole o ID numérico do Pixel da Meta para o anúncio otimizar no lead.
  metaPixelId: '',
  // Cole o Calendly (ou outro) quando existir. A página de obrigado passa a oferecer o horário.
  calendarUrl: '',
};

export const diagnosticWhatsAppText =
  'Olá, quero conhecer o ContDesk e agendar uma demonstração para meu escritório.';

export function buildWhatsAppUrl(text = diagnosticWhatsAppText) {
  return `https://wa.me/${site.whatsappNumber}?text=${encodeURIComponent(text)}`;
}
